export default __webpack_public_path__ + "static/media/img_coin.min.dbd64c60.png";